import styled from '@emotion/styled';
import React from 'react';
import { type ITheme, Shimmer } from '../../../../ui';
import { Tile } from '../../../../ui/new-components/Tile';
import {
	StyledFlexShortcutGrid,
	StyledFlexShortcutItem,
} from './StyledFlexShortcutGrid';
import { StyledShortcut } from './StyledShortcut';
import { StyledShortcuts } from './StyledShortcuts';
import type { IShortcut } from './types';

interface IShortcutsMainProps {
	shortcuts: IShortcut[];
}
export const ShortcutsGridContainer = ({ shortcuts }: IShortcutsMainProps) => (
	<StyledShortcuts>
		<StyledFlexShortcutGrid
			role="list"
			columns={[
				Math.max(Math.min(4, shortcuts?.length ?? 0), 3),
				{
					tablet: 2,
					mobile: 2,
				},
			]}
			number={shortcuts.length}
		>
			{shortcuts.map(({ href, icon, title, isEnabled, color, isNew }) => (
				<StyledFlexShortcutItem
					key={href}
					number={shortcuts.length}
					role="listitem"
				>
					{!isEnabled ? (
						<Shimmer aria-label="shimmer" style={{ flexGrow: 1 }}>
							<StyledShortcut href={href}>
								<StyledShortcutShimmer />
							</StyledShortcut>
						</Shimmer>
					) : (
						<Tile
							href={href}
							title={title}
							color={color}
							icon={icon}
							isNew={isNew}
						/>
					)}
				</StyledFlexShortcutItem>
			))}
		</StyledFlexShortcutGrid>
	</StyledShortcuts>
);

const StyledShortcutShimmer = styled.div<{}, ITheme>`
	width: 100%;
`;
